import * as tslib_1 from "tslib";
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import Select from "../../Selects/Select";

var Dropdown =
/** @class */
function (_super) {
  tslib_1.__extends(Dropdown, _super);

  function Dropdown() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.renderArrow = function () {
      var _a;

      var blockName = _this.props.blockName;
      return React.createElement("span", {
        className: cx('icon-custom-caret-down', (_a = {}, _a[blockName + "__arrow"] = blockName, _a))
      });
    };

    return _this;
  }

  Dropdown.prototype.render = function () {
    var _a = this.props,
        blockName = _a.blockName,
        // eslint-disable-line no-unused-vars
    options = _a.options,
        value = _a.value,
        placeholder = _a.children,
        disabled = _a.disabled,
        onChange = _a.onChange,
        onClose = _a.onClose,
        onOpen = _a.onOpen,
        isOpen = _a.isOpen,
        tooltipOptions = _a.tooltipOptions,
        other = tslib_1.__rest(_a, ["blockName", "options", "value", "children", "disabled", "onChange", "onClose", "onOpen", "isOpen", "tooltipOptions"]);

    return React.createElement("div", tslib_1.__assign({}, other), React.createElement(Select, {
      value: value,
      valueComponent: function valueComponent() {
        return placeholder;
      },
      onClose: onClose,
      onOpen: onOpen,
      isOpen: isOpen,
      options: options,
      onChange: onChange,
      renderArrow: this.renderArrow,
      placeholder: placeholder,
      disabled: disabled,
      inPortal: false,
      tooltipOptions: tooltipOptions
    }));
  };

  Dropdown.propTypes = {
    blockName: PropTypes.string,
    className: PropTypes.string,
    options: PropTypes.array,
    value: PropTypes.any,
    isOpen: PropTypes.bool,
    disabled: PropTypes.bool,
    children: PropTypes.node,
    onChange: PropTypes.func,
    onClose: PropTypes.func,
    onOpen: PropTypes.func,
    tooltipOptions: PropTypes.object
  };
  return Dropdown;
}(Component);

export default Dropdown;

try {
  // @ts-ignore
  Dropdown.__docgenInfo = {
    "description": "",
    "displayName": "Dropdown",
    "props": {}
  };
} catch (__react_docgen_typescript_loader_error) {}